module.exports = __webpack_public_path__ + "img/onboarding.39e1db95.svg";